// src/components/VerifiedTick.tsx

import React from 'react';

const VerifiedTick = () => {
  return (
    <i
      className="feather-check-circle ms-1"
      style={{
        color: '#1d9bf0',
        fontSize: 16,
        display: 'inline-flex',
        alignItems: 'center',
      }}
    />
  );
};

export default VerifiedTick;